import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';

import GroupedMenu from 'components/forms/inputs/select-grouped-menu';

import { isMobile } from 'constants';

export default class Select extends React.Component {
  static propTypes = {
    valueKey: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array
    ]),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    creatable: PropTypes.bool,
    groupBy: PropTypes.func,
    // Optional function which gets called onChange with the full value(s) selected
    onChangeFullValue: PropTypes.func
  };

  static defaultProps = {
    valueKey: 'value',
    labelKey: 'label',
    autoBlur: isMobile
  };

  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { valueKey, labelKey, value } = this.props;

    if (!value || !value[valueKey]) return;

    const nextValue = _.find(nextProps.options, { [valueKey]: value[valueKey] });
    const nextLabel = _.get(nextValue, labelKey);
    const currentLabel = _.get(value, labelKey);

    if (nextValue && nextLabel !== currentLabel) {
      this.props.onChange(nextValue);
    }
  }

  onChange(value) {
    // Return the valueKey for each selected option, not the full object
    // Fixes issue where filter queries get stored in page URL and URL gets
    // incredibly long very quickly if we return the full objects
    const { onChange, valueKey, onChangeFullValue } = this.props;

    if (onChangeFullValue) onChangeFullValue(value);

    if (_.isArray(value)) {
      onChange(_.map(value, valueKey));
    } else {
      onChange(_.get(value, [valueKey], null));
    }
  }

  getSelectValue(props) {
    const { value: selectValue, options, valueKey, multi } = props;

    // If this is not a multi select full of objects, return the option with a value at valueKey which
    // matches the selectValue in the store
    if (!multi) return _.find(options, (option) => option[valueKey] == selectValue); // eslint-disable-line eqeqeq

    // If this is a multi select full of objects:
    // return an array of options which have valueKeys
    return _.filter(options, (option) =>
      _.find(selectValue, (singleSelectValue) =>
        // Match using == because we sometimes have a number singleSelectValue and an equivalent number
        // contained in a string in option[valueKey], and we want these to match
        singleSelectValue == option[valueKey] // eslint-disable-line eqeqeq
      )
    );
  }

  arrowRenderer({ onMouseDown }) {
    return (
      <div
        className="Select-arrow-wrapper"
        onMouseDown={onMouseDown}
        onTouchEnd={onMouseDown}
      >
        <span className="Select-arrow" />
      </div>
    );
  }

  render() {
    // Onblur for React select doesn't return a value, which
    // breaks redux forms
    const passed = _.omit(this.props, ['onBlur', 'disabled', 'creatable']);
    
    // Disabled needs to be a boolean value so coerce it to one
    passed.disabled = !!this.props.disabled;

    // Get the actual selected options based on the value keys set in the store
    const value = this.getSelectValue(this.props);

    // ReactSelect uses a different selector for tags
    const Component = this.props.creatable ? ReactSelect.Creatable : ReactSelect;

    console.log(`-------------value--------------`, value);

    return (
      <Component
        {...passed}
        menuRenderer={this.props.groupBy ? (props) => <GroupedMenu {...props} {...passed} /> : undefined}
        value={value}
        arrowRenderer={this.arrowRenderer}
        onChange={this.onChange}
      />
    );
  }
}
